import { Appointment } from "../type";

const keyArray: (keyof Appointment)[] = [
  "name", "address", "date", "id", "fk_request_id", "fk_project_id"
];

export function SearchCalendar(
  appt: Appointment, 
  users: string[] = [],
  search: string, 
  keys: string[] = keyArray
) {
  const searchLower = search?.toLowerCase?.() || "";
  if (!searchLower) return true;

  const matchesAppt = keys.some((key) => {
    const value = appt[key as keyof Appointment];
    return value?.toString?.().toLowerCase?.().includes(searchLower);
  });

  const safeUsers = Array.isArray(users) ? users : [users].filter(Boolean);

  const matchesUser = safeUsers.some(user =>
    user?.toLowerCase?.().includes(searchLower)
  );

  return matchesAppt || matchesUser;
}

